import { render, staticRenderFns } from "./BusinessUnitEditDetails.vue?vue&type=template&id=1dbe12ea&scoped=true&"
import script from "./BusinessUnitEditDetails.vue?vue&type=script&lang=js&"
export * from "./BusinessUnitEditDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbe12ea",
  null
  
)

export default component.exports